// import React, { useEffect, useState } from "react";
// import {
//   User,
//   Mail,
//   Phone,
//   CalendarDays,
//   MapPin,
//   Heart,
//   ShoppingBag,
//   Trash2,
//   ChevronLeft,
//   ChevronRight,
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { fetchUserOrderHistory } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { addItemToCart } from "../../../Redux Toolkit/Customer/CartSlice";
// import {
//   addProductToWishlist,
//   getWishlistByUserId,
// } from "../../../Redux Toolkit/Customer/WishlistSlice";

// const UserDetails = () => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();

//   const { user, orders, auth, wishlist } = useAppSelector((store) => store);

//   const [wishlistPage, setWishlistPage] = useState(0);

//   const customer = user.user;
//   const addresses = customer?.addresses || [];
//   const defaultAddress = addresses[0];

//   const recentOrders = (orders.orders || []).slice().reverse().slice(0, 5);

//   const wishlistItems = (wishlist.wishlist?.products || []).slice(0, 5);
//   const visibleWishlistItems = wishlistItems.slice(
//     wishlistPage,
//     wishlistPage + 2
//   );

//   const canGoPrevious = wishlistPage > 0;
//   const canGoNext = wishlistPage + 2 < wishlistItems.length;

//   useEffect(() => {
//     dispatch(fetchUserOrderHistory(localStorage.getItem("jwt") || ""));
//     dispatch(getWishlistByUserId());
//   }, [auth.jwt, dispatch]);

//   const formatDate = (date?: string) => {
//     if (!date) return "Date not available";
//     return new Date(date).toLocaleDateString("en-GB").replace(/\//g, "-");
//   };

//   const handleAddToCart = (productId?: number) => {
//     if (!productId) return;

//     dispatch(
//       addItemToCart({
//         jwt: localStorage.getItem("jwt"),
//         request: {
//           productId,
//           size: "FREE",
//           quantity: 1,
//         },
//       })
//     );
//   };

//   const handleRemoveFromWishlist = (productId?: number) => {
//     if (!productId) return;

//     dispatch(addProductToWishlist({ productId })).then(() => {
//       dispatch(getWishlistByUserId());

//       if (wishlistPage > 0 && visibleWishlistItems.length === 1) {
//         setWishlistPage((prev) => Math.max(prev - 1, 0));
//       }
//     });
//   };

//   return (
//     <div className="space-y-6">
//       <section className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm min-h-[230px] sm:h-[280px]">
//         <div className="absolute inset-0">
//           <img
//             src="/profile-beads-bg.png"
//             alt="Profile background"
//             className="w-full h-full object-cover"
//           />
//         </div>

//         <div className="absolute inset-0 bg-white/35" />

//         <div className="relative z-10 flex flex-row items-center gap-4 p-4 sm:p-7 min-h-[230px] sm:h-full">
//           <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-white border-4 border-white shadow flex items-center justify-center overflow-hidden shrink-0">
//             <User size={52} className="text-gray-300 sm:w-16 sm:h-16" />
//           </div>

//           <div className="min-w-0">
//             <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 truncate">
//               {customer?.fullName || "Customer"}
//             </h1>

//             <div className="mt-4 space-y-2 text-sm text-gray-700">
//               <p className="flex items-center gap-3">
//                 <Mail size={17} className="shrink-0" />
//                 <span className="truncate">
//                   {customer?.email || "Email not available"}
//                 </span>
//               </p>

//               <p className="flex items-center gap-3">
//                 <Phone size={17} className="shrink-0" />
//                 <span>{customer?.mobile || "Mobile not available"}</span>
//               </p>

//               <p className="flex items-center gap-3">
//                 <CalendarDays size={17} className="shrink-0" />
//                 <span>Member since May 2023</span>
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="grid grid-cols-1 xl:grid-cols-2 gap-6">
//         <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
//           <div className="flex items-center justify-between mb-5">
//             <h2 className="flex items-center gap-3 text-lg font-semibold text-gray-900">
//               <User size={20} />
//               Personal Information
//             </h2>

//             <button className="text-primary-color text-sm font-medium">
//               Edit
//             </button>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-sm">
//             <div>
//               <p className="text-gray-500">Full Name</p>
//               <p className="font-medium text-gray-900 mt-1">
//                 {customer?.fullName || "Not available"}
//               </p>
//             </div>

//             <div>
//               <p className="text-gray-500">Email</p>
//               <p className="font-medium text-gray-900 mt-1 break-all">
//                 {customer?.email || "Not available"}
//               </p>
//             </div>

//             <div>
//               <p className="text-gray-500">Phone Number</p>
//               <p className="font-medium text-gray-900 mt-1">
//                 {customer?.mobile || "Not available"}
//               </p>
//             </div>

//             <div>
//               <p className="text-gray-500">Date of Birth</p>
//               <p className="font-medium text-gray-900 mt-1">Not available</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
//           <div className="flex items-center justify-between mb-5">
//             <h2 className="flex items-center gap-3 text-lg font-semibold text-gray-900">
//               <MapPin size={20} />
//               Addresses
//             </h2>

//             <button
//               onClick={() => navigate("/account/addresses")}
//               className="text-primary-color text-sm font-medium"
//             >
//               Manage Addresses
//             </button>
//           </div>

//           {defaultAddress ? (
//             <div className="text-sm text-gray-800 space-y-2">
//               <span className="inline-block bg-gray-100 text-primary-color text-xs font-semibold px-3 py-1 rounded-md mb-2">
//                 Default Address
//               </span>

//               <p className="font-semibold">{customer?.fullName}</p>
//               <p>{defaultAddress.address}</p>
//               <p>
//                 {defaultAddress.city}, {defaultAddress.state} -{" "}
//                 {defaultAddress.pinCode}
//               </p>
//               <p>{customer?.mobile || "Mobile not available"}</p>
//             </div>
//           ) : (
//             <div className="text-sm text-gray-500">No address added yet.</div>
//           )}
//         </div>
//       </section>

//       <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
//         <div className="flex items-center justify-between mb-5">
//           <h2 className="flex items-center gap-3 text-lg font-semibold text-gray-900">
//             <ShoppingBag size={20} />
//             Recent Orders
//           </h2>

//           <button
//             onClick={() => navigate("/account/orders")}
//             className="text-primary-color text-sm font-medium"
//           >
//             View All Orders
//           </button>
//         </div>

//         {recentOrders.length > 0 ? (
//           <div className="divide-y">
//             {recentOrders.map((order: any) => {
//               const firstItem = order.orderItems?.[0];
//               const product = firstItem?.product;

//               const handleViewDetails = () => {
//                 if (order.id && firstItem?.id) {
//                   navigate(`/account/orders/${order.id}/${firstItem.id}`);
//                 }
//               };

//               return (
//                 <div
//                   key={order.id}
//                   className="grid grid-cols-[80px_1fr] sm:grid-cols-[96px_minmax(0,1fr)_150px_120px_130px] gap-4 sm:items-center py-4"
//                 >
//                   <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-xl bg-gray-100 shrink-0 overflow-hidden">
//                     {order.orderItems?.length > 1 ? (
//                       <div
//                         className={`w-full h-full grid gap-[2px] ${order.orderItems.length === 2
//                             ? "grid-cols-2"
//                             : "grid-cols-2 grid-rows-2"
//                           }`}
//                       >
//                         {order.orderItems
//                           .slice(0, 4)
//                           .map((item: any, index: number) => {
//                             const isThreeItemLayout =
//                               order.orderItems.length === 3 && index === 0;

//                             return (
//                               <div
//                                 key={index}
//                                 className={`overflow-hidden bg-gray-100 ${isThreeItemLayout ? "row-span-2" : ""
//                                   }`}
//                               >
//                                 {item?.product?.images?.[0] ? (
//                                   <img
//                                     src={item.product.images[0]}
//                                     alt={item.product?.title || "Order item"}
//                                     className="w-full h-full object-cover"
//                                   />
//                                 ) : (
//                                   <div className="w-full h-full flex items-center justify-center">
//                                     <ShoppingBag
//                                       size={18}
//                                       className="text-primary-color"
//                                     />
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                       </div>
//                     ) : product?.images?.[0] ? (
//                       <img
//                         src={product.images[0]}
//                         alt={product.title || "Order item"}
//                         className="w-full h-full object-cover"
//                       />
//                     ) : (
//                       <div className="w-full h-full flex items-center justify-center">
//                         <ShoppingBag size={30} className="text-primary-color" />
//                       </div>
//                     )}
//                   </div>

//                   <div className="min-w-0">
//                     <p className="font-medium text-gray-900">
//                       Order #OD102694500000{order.id}
//                     </p>

//                     <p className="text-sm text-gray-500">
//                       {formatDate(order.orderDate)}
//                     </p>

//                     {product?.title && (
//                       <p className="text-sm text-gray-600 truncate mt-1">
//                         {product.title}
//                       </p>
//                     )}
//                   </div>

//                   <div className="col-start-2 sm:col-start-auto flex justify-start sm:justify-center">
//                     <span className="inline-flex rounded-md bg-green-50 text-green-700 px-3 py-1 text-xs font-semibold">
//                       {order.orderStatus || "Placed"}
//                     </span>
//                   </div>

//                   <div className="col-start-2 sm:col-start-auto flex justify-start sm:justify-center">
//                     <p className="font-semibold text-gray-900">
//                       ₹{order.totalSellingPrice || order.totalPrice || "0"}
//                     </p>
//                   </div>

//                   <div className="col-start-2 sm:col-start-auto flex justify-end sm:justify-center -mt-2 sm:mt-0">
//                     <button
//                       onClick={handleViewDetails}
//                       disabled={!order.id || !firstItem?.id}
//                       className="
//                       w-[150px] sm:w-auto
//                       border border-primary-color
//                       text-primary-color
//                       rounded-lg
//                       px-5 py-2.5
//                       text-sm font-semibold
//                       hover:bg-gray-100
//                       transition
//                       disabled:opacity-50 disabled:cursor-not-allowed
//                     "
//                     >
//                       View Order
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         ) : (
//           <p className="text-sm text-gray-500">No recent orders found.</p>
//         )}
//       </section>

//       <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
//         <div className="flex items-center justify-between gap-4 mb-5">
//           <h2 className="flex items-center gap-3 text-lg font-semibold text-gray-900">
//             <Heart size={20} />
//             Wishlist
//           </h2>

//           <div className="flex items-center gap-3">
//             {wishlistItems.length > 2 && (
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={() =>
//                     setWishlistPage((prev) => Math.max(prev - 2, 0))
//                   }
//                   disabled={!canGoPrevious}
//                   className="w-8 h-8 border rounded-full flex items-center justify-center hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
//                 >
//                   <ChevronLeft size={17} />
//                 </button>

//                 <button
//                   onClick={() =>
//                     setWishlistPage((prev) =>
//                       Math.min(prev + 2, wishlistItems.length - 2)
//                     )
//                   }
//                   disabled={!canGoNext}
//                   className="w-8 h-8 border rounded-full flex items-center justify-center hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
//                 >
//                   <ChevronRight size={17} />
//                 </button>
//               </div>
//             )}

//             <button
//               onClick={() => navigate("/wishlist")}
//               className="text-primary-color text-sm font-medium"
//             >
//               View Full Wishlist
//             </button>
//           </div>
//         </div>

//         {visibleWishlistItems.length > 0 ? (
//           <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
//             {visibleWishlistItems.map((item) => (
//               <div
//                 key={item.id}
//                 className="border border-gray-200 rounded-xl p-3 flex gap-4"
//               >
//                 <img
//                   src={item.images?.[0]}
//                   alt={item.title}
//                   onClick={() =>
//                     navigate(
//                       `/product-details/${item.category?.categoryId}/${item.id}`
//                     )
//                   }
//                   className="w-24 h-24 rounded-lg object-cover bg-gray-100 cursor-pointer"
//                 />

//                 <div className="flex-1 min-w-0">
//                   <div className="flex justify-between gap-3">
//                     <p
//                       onClick={() =>
//                         navigate(
//                           `/product-details/${item.category?.categoryId}/${item.id}`
//                         )
//                       }
//                       className="font-medium text-sm text-gray-900 line-clamp-2 cursor-pointer hover:text-primary-color"
//                     >
//                       {item.title}
//                     </p>

//                     <Heart
//                       size={20}
//                       className="text-primary-color fill-primary-color shrink-0"
//                     />
//                   </div>

//                   <div className="mt-2 flex flex-wrap items-center gap-2">
//                     <p className="font-semibold text-gray-900">
//                       ₹{item.sellingPrice}
//                     </p>

//                     {item.mrpPrice && (
//                       <p className="text-sm text-gray-400 line-through">
//                         ₹{item.mrpPrice}
//                       </p>
//                     )}

//                     {item.discountPercent !== undefined && (
//                       <p className="text-sm text-green-600 font-medium">
//                         {item.discountPercent}% off
//                       </p>
//                     )}
//                   </div>

//                   <p
//                     className={`text-sm mt-1 ${item.in_stock === false ? "text-red-500" : "text-green-600"
//                       }`}
//                   >
//                     {item.in_stock === false ? "Out of Stock" : "In Stock"}
//                   </p>

//                   <div className="flex items-center gap-2 mt-3">
//                     <button
//                       onClick={() => {
//                         handleAddToCart(item.id);
//                         handleRemoveFromWishlist(item.id);
//                       }}
//                       disabled={item.in_stock === false}
//                       className="flex-1 border border-primary-color text-primary-color rounded-lg py-2 text-sm font-medium hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                       Move to Cart
//                     </button>

//                     <button
//                       onClick={() => handleRemoveFromWishlist(item.id)}
//                       className="w-10 h-10 border rounded-lg flex items-center justify-center hover:bg-gray-100"
//                     >
//                       <Trash2 size={17} />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="border border-gray-200 rounded-xl p-6 text-center">
//             <Heart size={34} className="mx-auto text-gray-300" />
//             <p className="mt-3 text-sm font-medium text-gray-900">
//               Your wishlist is empty
//             </p>
//             <p className="text-sm text-gray-500 mt-1">
//               Products added to wishlist will appear here.
//             </p>
//           </div>
//         )}
//       </section>
//     </div>
//   );
// };

// export default UserDetails;



import React, { useEffect, useState } from "react";
import {
  User,
  Mail,
  Phone,
  CalendarDays,
  MapPin,
  Heart,
  ShoppingBag,
  Trash2,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { fetchUserOrderHistory } from "../../../Redux Toolkit/Customer/OrderSlice";
import { addItemToCart } from "../../../Redux Toolkit/Customer/CartSlice";
import {
  addProductToWishlist,
  getWishlistByUserId,
} from "../../../Redux Toolkit/Customer/WishlistSlice";
import { updateUserProfile } from "../../../Redux Toolkit/Customer/UserSlice";

const UserDetails = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { user, orders, auth, wishlist } = useAppSelector((store) => store);

  const [wishlistPage, setWishlistPage] = useState(0);
  const [isEditingPersonalInfo, setIsEditingPersonalInfo] = useState(false);
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");

  const customer = user.user;
  // const addresses = customer?.addresses || [];
  // const defaultAddress = addresses[0];

  const addresses =
    user.addresses && user.addresses.length > 0
      ? user.addresses
      : customer?.addresses || [];

  const defaultAddress =
    addresses.find((address: any) => address.defaultAddress) || addresses[0];

  const recentOrders = (orders.orders || []).slice().reverse().slice(0, 5);

  const wishlistItems = [...(wishlist.wishlist?.products || [])]
    .sort((a: any, b: any) => (a.id || 0) - (b.id || 0))
    .slice(0, 5);
  const visibleWishlistItems = wishlistItems.slice(
    wishlistPage,
    wishlistPage + 2
  );

  const canGoPrevious = wishlistPage > 0;
  const canGoNext = wishlistPage + 2 < wishlistItems.length;

  const [dateOfBirth, setDateOfBirth] = useState("");

  useEffect(() => {
    dispatch(fetchUserOrderHistory(localStorage.getItem("jwt") || ""));
    dispatch(getWishlistByUserId());
  }, [auth.jwt, dispatch]);

  useEffect(() => {
    setFullName(customer?.fullName || "");
    setMobile(customer?.mobile || "");
    setDateOfBirth(customer?.dateOfBirth || "");
  }, [customer?.fullName, customer?.mobile, customer?.dateOfBirth]);

  useEffect(() => {
    if (user.profileUpdated) {
      setIsEditingPersonalInfo(false);
    }
  }, [user.profileUpdated]);

  const formatDate = (date?: string) => {
    if (!date) return "Date not available";
    return new Date(date).toLocaleDateString("en-GB").replace(/\//g, "-");
  };

  const handleEditPersonalInfo = () => {
    setFullName(customer?.fullName || "");
    setMobile(customer?.mobile || "");
    setIsEditingPersonalInfo(true);
  };

  const handleCancelPersonalInfo = () => {
    setFullName(customer?.fullName || "");
    setMobile(customer?.mobile || "");
    setDateOfBirth(customer?.dateOfBirth || "");
    setIsEditingPersonalInfo(false);
  };

  const handleSavePersonalInfo = () => {
    const jwt = localStorage.getItem("jwt");
    if (!jwt) return;

    dispatch(
      updateUserProfile({
        jwt,
        userData: {
          fullName,
          mobile,
          dateOfBirth,
        },
      })
    );
  };

  const handleAddToCart = (productId?: number) => {
    if (!productId) return;

    dispatch(
      addItemToCart({
        jwt: localStorage.getItem("jwt"),
        request: {
          productId,
          size: "FREE",
          quantity: 1,
        },
      })
    );
  };

  const handleRemoveFromWishlist = (productId?: number) => {
    if (!productId) return;

    dispatch(addProductToWishlist({ productId })).then(() => {
      dispatch(getWishlistByUserId());

      if (wishlistPage > 0 && visibleWishlistItems.length === 1) {
        setWishlistPage((prev) => Math.max(prev - 1, 0));
      }
    });
  };

  return (
    <div className="space-y-6">
      <section className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm min-h-[230px] sm:h-[280px]">
        <div className="absolute inset-0">
          <img
            src="/profile-beads-bg.png"
            alt="Profile background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-white/35" />

        <div className="relative z-10 flex flex-row items-center gap-4 p-4 sm:p-7 min-h-[230px] sm:h-full">
          <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-white border-4 border-white shadow flex items-center justify-center overflow-hidden shrink-0">
            <User size={52} className="text-gray-300 sm:w-16 sm:h-16" />
          </div>

          <div className="min-w-0">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 truncate">
              {customer?.fullName || "Customer"}
            </h1>

            <div className="mt-4 space-y-2 text-sm text-gray-700">
              <p className="flex items-center gap-3">
                <Mail size={17} className="shrink-0" />
                <span className="truncate">
                  {customer?.email || "Email not available"}
                </span>
              </p>

              <p className="flex items-center gap-3">
                <Phone size={17} className="shrink-0" />
                <span>{customer?.mobile || "Mobile not available"}</span>
              </p>

              <p className="flex items-center gap-3">
                <CalendarDays size={17} className="shrink-0" />
                <span>Member since May 2023</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
          <div className="flex items-center justify-between mb-5">
            <h2 className="flex items-center gap-3 text-lg font-semibold text-gray-900">
              <User size={20} />
              Personal Information
            </h2>

            {!isEditingPersonalInfo ? (
              <button
                onClick={handleEditPersonalInfo}
                className="text-primary-color text-sm font-medium"
              >
                Edit
              </button>
            ) : (
              <div className="flex items-center gap-3">
                <button
                  onClick={handleCancelPersonalInfo}
                  className="text-gray-500 text-sm font-medium"
                >
                  Cancel
                </button>

                <button
                  onClick={handleSavePersonalInfo}
                  disabled={user.loading}
                  className="text-primary-color text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {user.loading ? "Saving..." : "Save"}
                </button>
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-sm">
            <div>
              <p className="text-gray-500">Full Name</p>

              {isEditingPersonalInfo ? (
                <input
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  className="w-full mt-1 border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-primary-color"
                  placeholder="Enter full name"
                />
              ) : (
                <p className="font-medium text-gray-900 mt-1">
                  {customer?.fullName || "Not available"}
                </p>
              )}
            </div>

            <div>
              <p className="text-gray-500">Email</p>

              {isEditingPersonalInfo ? (
                <input
                  value={customer?.email || ""}
                  disabled
                  className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 bg-gray-100 text-gray-500 cursor-not-allowed"
                />
              ) : (
                <p className="font-medium text-gray-900 mt-1 break-all">
                  {customer?.email || "Not available"}
                </p>
              )}
            </div>

            <div>
              <p className="text-gray-500">Phone Number</p>

              {isEditingPersonalInfo ? (
                <input
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  className="w-full mt-1 border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-primary-color"
                  placeholder="Enter phone number"
                />
              ) : (
                <p className="font-medium text-gray-900 mt-1">
                  {customer?.mobile || "Not available"}
                </p>
              )}
            </div>

            <div>
              <p className="text-gray-500">Date of Birth</p>

              {isEditingPersonalInfo ? (
                <>
                  <input
                    type="date"
                    value={dateOfBirth}
                    max={new Date(Date.now() - 86400000)
                      .toISOString()
                      .split("T")[0]}
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    className="w-full mt-1 border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-primary-color"
                  />
                </>
              ) : (
                <p className="font-medium text-gray-900 mt-1">
                  {customer?.dateOfBirth
                    ? new Date(customer.dateOfBirth).toLocaleDateString("en-GB")
                    : "Not available"}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
          <div className="flex items-center justify-between mb-5">
            <h2 className="flex items-center gap-3 text-lg font-semibold text-gray-900">
              <MapPin size={20} />
              Addresses
            </h2>

            <button
              onClick={() => navigate("/account/addresses")}
              className="text-primary-color text-sm font-medium"
            >
              Manage Addresses
            </button>
          </div>

          {defaultAddress ? (
            <div className="text-sm text-gray-800 space-y-2">
              <span className="inline-block bg-gray-100 text-primary-color text-xs font-semibold px-3 py-1 rounded-md mb-2">
                Default Address
              </span>

              <p className="font-semibold">{customer?.fullName}</p>
              <p>{defaultAddress.address}</p>
              <p>
                {defaultAddress.city}, {defaultAddress.state} -{" "}
                {defaultAddress.pinCode}
              </p>
              <p>{customer?.mobile || "Mobile not available"}</p>
            </div>
          ) : (
            <div className="text-sm text-gray-500">No address added yet.</div>
          )}
        </div>
      </section>

      <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="flex items-center gap-3 text-lg font-semibold text-gray-900">
            <ShoppingBag size={20} />
            Recent Orders
          </h2>

          <button
            onClick={() => navigate("/account/orders")}
            className="text-primary-color text-sm font-medium"
          >
            View All Orders
          </button>
        </div>

        {recentOrders.length > 0 ? (
          <div className="divide-y">
            {recentOrders.map((order: any) => {
              const firstItem = order.orderItems?.[0];
              const product = firstItem?.product;

              const handleViewDetails = () => {
                if (order.id && firstItem?.id) {
                  navigate(`/account/orders/${order.id}/${firstItem.id}`);
                }
              };

              return (
                <div
                  key={order.id}
                  className="grid grid-cols-[80px_1fr] sm:grid-cols-[96px_minmax(0,1fr)_150px_120px_130px] gap-4 sm:items-center py-4"
                >
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-xl bg-gray-100 shrink-0 overflow-hidden">
                    {order.orderItems?.length > 1 ? (
                      <div
                        className={`w-full h-full grid gap-[2px] ${order.orderItems.length === 2
                          ? "grid-cols-2"
                          : "grid-cols-2 grid-rows-2"
                          }`}
                      >
                        {order.orderItems
                          .slice(0, 4)
                          .map((item: any, index: number) => {
                            const isThreeItemLayout =
                              order.orderItems.length === 3 && index === 0;

                            return (
                              <div
                                key={index}
                                className={`overflow-hidden bg-gray-100 ${isThreeItemLayout ? "row-span-2" : ""
                                  }`}
                              >
                                {item?.product?.images?.[0] ? (
                                  <img
                                    src={item.product.images[0]}
                                    alt={item.product?.title || "Order item"}
                                    className="w-full h-full object-cover"
                                  />
                                ) : (
                                  <div className="w-full h-full flex items-center justify-center">
                                    <ShoppingBag
                                      size={18}
                                      className="text-primary-color"
                                    />
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    ) : product?.images?.[0] ? (
                      <img
                        src={product.images[0]}
                        alt={product.title || "Order item"}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <ShoppingBag size={30} className="text-primary-color" />
                      </div>
                    )}
                  </div>

                  <div className="min-w-0">
                    <p className="font-medium text-gray-900">
                      Order #OD102694500000{order.id}
                    </p>

                    <p className="text-sm text-gray-500">
                      {formatDate(order.orderDate)}
                    </p>

                    {product?.title && (
                      <p className="text-sm text-gray-600 truncate mt-1">
                        {product.title}
                      </p>
                    )}
                  </div>

                  <div className="col-start-2 sm:col-start-auto flex justify-start sm:justify-center">
                    <span className="inline-flex rounded-md bg-green-50 text-green-700 px-3 py-1 text-xs font-semibold">
                      {order.orderStatus || "Placed"}
                    </span>
                  </div>

                  <div className="col-start-2 sm:col-start-auto flex justify-start sm:justify-center">
                    <p className="font-semibold text-gray-900">
                      ₹{order.totalSellingPrice || order.totalPrice || "0"}
                    </p>
                  </div>

                  <div className="col-start-2 sm:col-start-auto flex justify-end sm:justify-center -mt-2 sm:mt-0">
                    <button
                      onClick={handleViewDetails}
                      disabled={!order.id || !firstItem?.id}
                      className="w-[150px] sm:w-auto border border-primary-color text-primary-color rounded-lg px-5 py-2.5 text-sm font-semibold hover:bg-gray-100 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      View Order
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-sm text-gray-500">No recent orders found.</p>
        )}
      </section>

      <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
        <div className="flex items-center justify-between gap-4 mb-5">
          <h2 className="flex items-center gap-3 text-lg font-semibold text-gray-900">
            <Heart size={20} />
            Wishlist
          </h2>

          <div className="flex items-center gap-3">
            {wishlistItems.length > 2 && (
              <div className="flex items-center gap-2">
                <button
                  onClick={() =>
                    setWishlistPage((prev) => Math.max(prev - 2, 0))
                  }
                  disabled={!canGoPrevious}
                  className="w-8 h-8 border rounded-full flex items-center justify-center hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  <ChevronLeft size={17} />
                </button>

                <button
                  onClick={() =>
                    setWishlistPage((prev) =>
                      Math.min(prev + 2, wishlistItems.length - 2)
                    )
                  }
                  disabled={!canGoNext}
                  className="w-8 h-8 border rounded-full flex items-center justify-center hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  <ChevronRight size={17} />
                </button>
              </div>
            )}

            <button
              onClick={() => navigate("/wishlist")}
              className="text-primary-color text-sm font-medium"
            >
              View Full Wishlist
            </button>
          </div>
        </div>

        {visibleWishlistItems.length > 0 ? (
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
            {visibleWishlistItems.map((item) => (
              <div
                key={item.id}
                className="border border-gray-200 rounded-xl p-3 flex gap-4"
              >
                <img
                  src={item.images?.[0]}
                  alt={item.title}
                  onClick={() =>
                    navigate(
                      `/product-details/${item.category?.categoryId}/${item.id}`
                    )
                  }
                  className="w-24 h-24 rounded-lg object-cover bg-gray-100 cursor-pointer"
                />

                <div className="flex-1 min-w-0">
                  <div className="flex justify-between gap-3">
                    <p
                      onClick={() =>
                        navigate(
                          `/product-details/${item.category?.categoryId}/${item.id}`
                        )
                      }
                      className="font-medium text-sm text-gray-900 line-clamp-2 cursor-pointer hover:text-primary-color"
                    >
                      {item.title}
                    </p>

                    <Heart
                      size={20}
                      className="text-primary-color fill-primary-color shrink-0"
                    />
                  </div>

                  <div className="mt-2 flex flex-wrap items-center gap-2">
                    <p className="font-semibold text-gray-900">
                      ₹{item.sellingPrice}
                    </p>

                    {item.mrpPrice && (
                      <p className="text-sm text-gray-400 line-through">
                        ₹{item.mrpPrice}
                      </p>
                    )}

                    {item.discountPercent !== undefined && (
                      <p className="text-sm text-green-600 font-medium">
                        {item.discountPercent}% off
                      </p>
                    )}
                  </div>

                  <p
                    className={`text-sm mt-1 ${item.in_stock === false ? "text-red-500" : "text-green-600"
                      }`}
                  >
                    {item.in_stock === false ? "Out of Stock" : "In Stock"}
                  </p>

                  <div className="flex items-center gap-2 mt-3">
                    <button
                      onClick={() => {
                        handleAddToCart(item.id);
                        handleRemoveFromWishlist(item.id);
                      }}
                      disabled={item.in_stock === false}
                      className="flex-1 border border-primary-color text-primary-color rounded-lg py-2 text-sm font-medium hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Move to Cart
                    </button>

                    <button
                      onClick={() => handleRemoveFromWishlist(item.id)}
                      className="w-10 h-10 border rounded-lg flex items-center justify-center hover:bg-gray-100"
                    >
                      <Trash2 size={17} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="border border-gray-200 rounded-xl p-6 text-center">
            <Heart size={34} className="mx-auto text-gray-300" />
            <p className="mt-3 text-sm font-medium text-gray-900">
              Your wishlist is empty
            </p>
            <p className="text-sm text-gray-500 mt-1">
              Products added to wishlist will appear here.
            </p>
          </div>
        )}
      </section>
    </div>
  );
};

export default UserDetails;